import React, { useRef } from 'react';
import { PARTICLE_NAMES } from '../../game/constants';
import type { Locale } from '../../i18n';
import { getHoverName } from '../../i18n';

interface InfoPanelProps {
    hoverInfo: { name: string; temp: number } | null;
    locale: Locale;
}

export const InfoPanel: React.FC<InfoPanelProps> = ({ hoverInfo, locale }) => {
    // 记录上一次有效的悬停信息，用于在淡出动画时保持显示内容
    const lastValidHoverInfoRef = useRef<{ name: string; temp: number } | null>(null);
    if (hoverInfo) {
        lastValidHoverInfoRef.current = hoverInfo;
    }
    const displayInfo = hoverInfo || lastValidHoverInfoRef.current;
    const rawName = displayInfo?.name ?? "-";
    const zhName = displayInfo ? (PARTICLE_NAMES[displayInfo.name] || displayInfo.name) : "-";
    const displayName = getHoverName(locale, rawName, zhName);

    return (
        <div className={`
            pointer-events-none transition-all duration-300 ease-in-out origin-top-left
            flex items-center gap-3 bg-slate-900/60 backdrop-blur-md px-3 py-1.5 rounded-full border border-slate-700/30
            ${hoverInfo ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 -translate-y-2 scale-95'}
        `}>
            <div className="text-sm font-bold text-white/90 whitespace-nowrap">
                {displayName}
            </div>
            <div className={`text-xs font-mono font-medium px-1.5 py-0.5 rounded bg-black/20 whitespace-nowrap ${
                (displayInfo?.temp ?? 0) > 100 ? 'text-rose-400' : 
                (displayInfo?.temp ?? 0) < 0 ? 'text-cyan-400' : 
                'text-emerald-400'
            }`}>
                {displayInfo?.temp ?? 0}°C
            </div>
        </div>
    );
};
